import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import VueRouter from 'vue-router'
import VueI18n from 'vue-i18n'
import locale from 'element-ui/lib/locale/lang/en'
import store from './store/'
import Vuex from 'vuex'
import router from './router'
import messages from '@/i18n'
import WyswigInput from '@/components/WyswigInput'
import FormLanguageSwitcher from '@/components/FormLanguageSwitcher'
import ImageInputComponent from '@/components/ImageInputComponent'
import FileInputComponent from '@/components/FileInputComponent'
import LinkComponent from '@/components/LinkComponent'
import FormsetHeader from '@/components/FormsetHeader'
import '@/mixins'
import Editor from '@tinymce/tinymce-vue';
import ColorPicker from '@/components/ColorPicker'
import SearchListForm from '@/components/SearchListForm'

import '@/styles/theme/index.css'
import 'font-awesome/css/font-awesome.min.css'

Vue.use(ElementUI, {locale})
Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(VueI18n)

Vue.use(Editor)


const i18n = new VueI18n({
	locale: 'pl', // set locale
	fallbackLocale: 'pl',
	messages // set locale messages
})

// global components
Vue.component('editor', Editor)
Vue.component('wyswig-input', WyswigInput)
Vue.component('form-language-switcher', FormLanguageSwitcher)
Vue.component('image-input-component', ImageInputComponent)
Vue.component('file-input-component', FileInputComponent)
Vue.component('link-component', LinkComponent)
Vue.component('formset-header', FormsetHeader)
Vue.component('el-color-picker', ColorPicker)
Vue.component('search-list-form', SearchListForm)

new Vue({
	router,
	store,
	i18n,
	render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js